import { Button, DrawerFooter, Heading, Span } from "@icg360/design-system";

import { MSSDrawer, MSSDrawerHeader } from "components/mss-drawer";
import drawerStyles from "components/mss-drawer/mss-drawer.module.scss";
import { NotificationItem } from "components/notifications/notifications-drawer/notification-item";
import styles from "components/notifications/notifications-drawer/notifications-drawer.module.scss";
import CheckIcon from "images/icon-check.svg?react";
import { trackEvent } from "utils";

import { useNotifications } from "../context";

export const NotificationsDrawer = () => {
  const { notifications, total, isDrawerOpen, closeDrawer, dismiss } =
    useNotifications();
  const hasNotifications = total > 0;

  return (
    <MSSDrawer isOpen={isDrawerOpen} onClose={closeDrawer}>
      <div className={styles.mssHeaderSection}>
        <MSSDrawerHeader
          title="Notifications"
          onClose={closeDrawer}
          closeButtonTestId="notifications-drawer-switcher-close"
        />
      </div>
      {hasNotifications ? (
        <MSSDrawer.Body className={styles.mssBody}>
          <div className={styles.drawerContent}>
            <NotificationItem />
          </div>
        </MSSDrawer.Body>
      ) : (
        <MSSDrawer.Body className={styles.emptyMssBody}>
          <div className={styles.emptyDrawerContent}>
            <div className={styles.notificationEmptyImage}>
              <CheckIcon className={styles.checkImage} />
            </div>
            <Heading
              size="md"
              tag="h3"
              className={styles.notificationsEmptyState}
            >
              You're all caught up!
            </Heading>
            <Span size="sm" className={styles.emptyNotificationsDescription}>
              We'll let you know when something needs your attention.
            </Span>
          </div>
        </MSSDrawer.Body>
      )}
      <div className={styles.footer}>
        <DrawerFooter className={drawerStyles.drawerFooterPadding}>
          <div className={drawerStyles.footerActions}>
            <Button
              appearance="tertiary"
              className={drawerStyles.footerBtn}
              disabled={!hasNotifications}
              onPress={() => {
                trackEvent("Notification dismiss all clicked", {
                  offerInternalNames: notifications.map(
                    (notification) => notification.offerInternalName,
                  ),
                  count: total,
                });
                dismiss(notifications);
              }}
              data-testid="clear-all-button"
            >
              Clear All
            </Button>
          </div>
        </DrawerFooter>
      </div>
    </MSSDrawer>
  );
};
